/**
 * A lead source name as a venue's mappings know it: trimmed, lowercased, inner
 * spaces collapsed, so "Paid Search" and " paid  search" are one name
 * (docs/ad-attribution.spec.md). Lead source names are free text in GoHighLevel.
 */
export function sourceKey(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, ' ')
}
